import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import AvatarEditor from "react-avatar-editor";
import Button from "../Button/Button";
import { toast } from "react-toastify";
import trans from "../../../utils";

const UpdatePic = ({ onPictureSelect, picture, setPicUpdated }) => {
	const basicImage = `${process.env.PUBLIC_URL}/assets/Avatar.svg`;
	const defaultImage = picture
		? picture
		: `${process.env.PUBLIC_URL}/assets/Avatar.svg`; // Default image
	const [image, setImage] = useState(defaultImage);
	const [file, setFile] = useState(null); // Store the original file
	const [undo, setUndo] = useState(false);

	// Handle image drop
	const handleDrop = (acceptedFiles, rejectedFiles) => {
		if (rejectedFiles.length > 0) {
			toast.info(trans("Only JPEG, JPG, and PNG image formats are allowed."), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}

		const newFile = acceptedFiles[0];
		if (newFile) {
			const maxSizeInMB = 1;
			const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

			if (newFile.size > maxSizeInBytes) {
				toast.info(
					`${trans("Image size should not exceed")} ${maxSizeInMB}${trans(
						"MB"
					)}.`,
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
				return;
			}
			setImage(URL.createObjectURL(newFile)); // Set image for preview
			setFile(newFile); // Store the file
			setUndo(false); // Reset undo state
			if (onPictureSelect) {
				onPictureSelect(newFile);
				setPicUpdated(true);
			}
		}
	};

	// Handle delete image
	const handleDelete = () => {
		setImage(basicImage); // Reset to the basic image
		setFile(null); // Clear the file
		if (onPictureSelect) {
			onPictureSelect(null); // Notify parent to set picture to null
			setPicUpdated(true);
		}
	};

	const currentImage = image || defaultImage;

	useEffect(() => {
		if (picture) {
			setImage(picture);
		} else {
			setImage(`${process.env.PUBLIC_URL}/assets/Avatar.svg`);
		}
	}, [picture]);

	return (
		<div className="mb-24">
			<Dropzone
				onDrop={handleDrop}
				accept={{ "image/jpeg": [], "image/png": [], "image/jpg": [] }}
				maxFiles={1}
				multiple={false}
			>
				{({ getRootProps, getInputProps, open }) => (
					<div className="text-center">
						<div {...getRootProps()} className="profile-picture-container">
							<AvatarEditor
								width={102}
								height={102}
								image={currentImage}
								border={0}
								className="profile-picture-container"
							/>
							<input {...getInputProps()} />
						</div>
						<div className="text-center mt-2">
							<Button
								htmlType="button"
								type={"primary"}
								text={trans("Upload Image")}
								onClick={open}
							/>
						</div>
						{image !== basicImage && (
							<div className="text-center mt-2">
								<Button
									htmlType="button"
									type={"default"}
									danger={true}
									text={trans("Delete Image")}
									onClick={handleDelete}
								/>
							</div>
						)}
					</div>
				)}
			</Dropzone>
		</div>
	);
};

export default UpdatePic;
